import styles from './DefaultDescription.style.m.css';

export const DefaultDescription = ({ text }) => <span className={styles.text}>{text}</span>;
